/** Help & support (ADR-0093): Administration, Administrators only. A ticket is
 *  `${HELP_SUPPORT_PATH}/<ticket id>`. Separate from `TICKETS_PATH`, the Support
 *  tickets of the Validation Solution. */
export const HELP_SUPPORT_PATH = "/admin/help-support";
export const HELP_SUPPORT_NEW_PATH = `${HELP_SUPPORT_PATH}/new`;
